
export function smallScreenActive () {
  return window.innerWidth < 900
}
